import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import Moment from 'moment'

// import API_BASE from '../../../../api/apiBase'
// import API_CONFIG from '../../../../api/apiConfig'

import * as storeActions from '../store/actions/stock_suppliers'
import { importExcel } from '../../../../store/actions/commonAction'

import { Drawer, Button, Space, Form, Upload, Switch, Select, Input, notification, List } from 'antd'
import { InboxOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons'

import languageManager from '../../../../services/languageManager'
import Loader from '../../../common/PageElements/Loader'

class DrawerImportStocks extends Component {
   state = {
      ...this.props,
      componentLoader: true,
      formLoader: false,
      formValues: {},
      model: {},
      worksheets: [],
      headers: [],
      currentHeaders: [],
      componentLanguage: this.props.authState.defaultLanguage
   }
   formRef = React.createRef();

   componentDidMount() {
      const formValues = {
         language: this.state.componentLanguage,
         wait_confirmation: true
      }
      Promise.all([
         this.getModel()
      ]).then(() => {
         this.setState({
            formValues: formValues,
            componentLoader: false
         });
      });
   }

   shouldComponentUpdate = (nextProps, nextState) => {
      // console.log('DRAWER IMPORT PROGRESSIVE - Should component update', nextProps, this.state)
      if (_.isEqual(nextProps.visible, this.state.visible) && _.isEqual(nextState.componentLoader, this.state.componentLoader)) {
         return false
      }
      return true
   }

   componentDidUpdate = (prevProps, prevState) => {
      if (!_.isEqual(prevProps.visible, this.props.visible)) {
         this.setState({
            worksheets: [],
            headers: [],
            currentHeaders: []
         })
         this.formRef.current.resetFields()
      }
   }

   getModel = () => {
      storeActions.getModel()
         .then(response => {
            try {
               console.log('MODEL', response.data)
               this.setState({ model: response.data })
            } catch (e) {
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               console.log(e)
            }
         }).catch((e) => {
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: e.error ? (
                  <List
                     size="small"
                     split={false}
                     dataSource={e.error}
                     renderItem={item => <List.Item>{item}</List.Item>}
                  />
               ) : languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               duration: 0
            })
         })
   }

   setWorksheets = (worksheets, headers) => {
      this.formRef.current.setFieldsValue({ worksheet: 0 })
      this.setState({ worksheets: worksheets, headers: headers, currentHeaders: headers[0] })
   }
   onChangeWorksheet = value => {
      console.log('CHANGE WORKSHEET', value)
      let currentHeaders = []
      if (!_.isUndefined(value)) {
         currentHeaders = this.state.headers[value]
         console.log('CURRENT HEADERS', currentHeaders)
      }
      this.setState({ currentHeaders: currentHeaders })
   }

   onClose = () => {
      this.state.onClose()
   }
   onFinish = values => {
      console.log('FORM VALUES', values)
      this.setState({ formLoader: true })
      let data = {};
      data.language = values.language;
      data.file_path = values.fileImport[0].response.data.file_path;
      data.file_name = values.fileImport[0].response.data.file_name;
      data.supplier_id = values.supplier_id
      data.brand_id = values.brand_id
      data.worksheet_index = values.worksheet
      data.wait_confirmation = values.wait_confirmation
      data.has_priority = values.has_priority
      delete values.fileImport
      delete values.supplier_id
      delete values.brand_id
      delete values.worksheet
      data.model_map = values
      // data.file_type = values.file_type;
      if (!data.file_path || !data.file_name) {
         this.setState({ formLoader: false, draggerDisable: false });
         notification.error({
            message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
            description: languageManager.getMessage(this.props.commonState, 'notification.error.dataNotValid'),
            duration: 0
         })
      }
      else {
         console.log("Data to import", data)
         storeActions.importFromFile(data)
            .then(response => {
               try {
                  this.state.onSubmit()
                  notification.success({
                     message: languageManager.getMessage(this.props.commonState, 'notification.confirm.title'),
                     description: languageManager.getMessage(this.props.commonState, this.state.action === 'edit' ? 'notification.confirm.updateOk' : 'notification.confirm.insertOk'),
                  })
               } catch (e) {
                  notification.error({
                     message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                     description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  })
                  console.log(e)
               } finally {
                  this.setState({ formLoader: false })
               }
            }).catch((e) => {
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: e.error ? (
                     <List
                        size="small"
                        split={false}
                        dataSource={e.error}
                        renderItem={item => <List.Item>{item}</List.Item>}
                     />
                  ) : languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
                  duration: 0
               })
               this.setState({ formLoader: false })
            });
      }
   };

   render() {
      if (this.state.componentLoader) return <Loader />
      console.log('Render IMPORT drawer', this.props)
      const { Option } = Select
      const scope = this
      const model = this.state.model

      const layout = {
         labelCol: { span: 8 },
         wrapperCol: { span: 16 },
      };

      const normFile = e => {
         console.log('Upload event:', e);
         if (Array.isArray(e)) {
            return e;
         }
         return e && e.fileList;
      }
      const draggerProps = {
         name: 'file',
         multiple: false,
         data: { filetype: 'stock_supplier' },
         // disabled: this.state.draggerDisable,
         customRequest: importExcel,
         onChange(info) {
            scope.setState({ draggerDisable: info.fileList.length });
            console.log("CHANGE: ", info);
            const { status } = info.file;
            // if (status !== 'uploading') {
            //    console.log(info.file, info.fileList);
            // }
            if (status === 'done') {
               console.log(info)
               const responseData = info.file.response.data
               if (info.file.response.success === true) {
                  notification.success({
                     message: languageManager.getMessage(scope.props.commonState, 'notification.confirm.title'),
                     description: info.file.name + ': ' + languageManager.getMessage(scope.props.commonState, 'notification.confirm.uploadOk'),
                  })
                  scope.setWorksheets(responseData.worksheets, responseData.headers)
                  // scope.setState({ worksheets: responseData.worksheets, headers: responseData.headers })
               }
               // if()
               // message.error(`${info.file.name} file upload failed.`)
               // message.success(`${info.file.name} file uploaded successfully.`)
               // this.setState({fileUploaded:true, })
            } else if (status === 'error') {
               notification.error({
                  message: languageManager.getMessage(scope.props.commonState, 'notification.confirm.title'),
                  description: info.file.name + ': ' + languageManager.getMessage(scope.props.commonState, 'notification.error.uploadKo'),
               })
               // message.error(`${info.file.name} file upload failed.`)
            }
         },
         // onDrop(e) {
         //    console.log(e)
         // }
      }

      const form = (
         <Form
            {...layout}
            ref={this.formRef}
            id="FormImportSupplierStocks"
            name="basic"
            initialValues={this.state.formValues}
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
         >
            <Form.Item
               name="fileImport"
               rules={[{ required: true, message: 'Scegli un file' }]}
               valuePropName="fileList"
               getValueFromEvent={normFile}
               colon={false}
               wrapperCol={24}
            >
               <Upload.Dragger {...draggerProps}>
                  <p className="ant-upload-drag-icon">
                     <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload</p>
                  <p className="ant-upload-hint">
                     Support for a single or bulk upload. Strictly prohibit from uploading company data or other
                     band files
                  </p>
               </Upload.Dragger>
            </Form.Item>
            {
               !_.isEmpty(this.state.worksheets) ? (
                  <Form.Item
                     label={languageManager.getMessage(this.props.commonState, 'component.label.worksheet')}
                     name="worksheet"
                     rules={[{ required: true }]}
                  >
                     <Select
                        showSearch
                        allowClear={true}
                        style={{ width: 200 }}
                        placeholder="Seleziona il foglio di lavoro"
                        optionFilterProp="children"
                        onChange={this.onChangeWorksheet}
                     >
                        {
                           this.state.worksheets.map((worksheetName, index) => {
                              return <Option key={index} value={index}>{worksheetName}</Option>
                           })
                        }
                     </Select>
                  </Form.Item>
               ) : null
            }
            <Form.Item
               label={languageManager.getMessage(this.props.commonState, 'component.label.supplier')}
               name="supplier_id"
               rules={[{ required: true }]}
            >
               <Select
                  showSearch
                  allowClear={true}
                  style={{ width: 200 }}
                  placeholder="Seleziona il fornitore"
                  optionFilterProp="children"
               >
                  {
                     this.state.complements.suppliersList.map((supplier, index) => {
                        return <Option key={supplier.id} value={supplier.id}>{supplier.name}</Option>
                     })
                  }
               </Select>
            </Form.Item>
            <Form.Item
               label={languageManager.getMessage(this.props.commonState, 'component.label.brand')}
               name="brand_id"
               rules={[{ required: true }]}
            >
               <Select
                  showSearch
                  allowClear={true}
                  style={{ width: 200 }}
                  placeholder="Seleziona il brand"
                  optionFilterProp="children"
               >
                  {
                     this.state.complements.brandsList.map((brand, index) => {
                        return <Option key={brand.id} value={brand.id}>{brand.name}</Option>
                     })
                  }
               </Select>
            </Form.Item>
            <Form.Item
               label={languageManager.getMessage(this.props.commonState, 'component.label.wait_confirmation')}
               name="wait_confirmation"
               valuePropName='checked'
            >
               <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
               />
            </Form.Item>
            <Form.Item
               label={languageManager.getMessage(this.props.commonState, 'component.label.has_priority')}
               name="has_priority"
               valuePropName='checked'
            >
               <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
               />
            </Form.Item>
            {
               Object.keys(model).map((key, index) => {
                  // console.log('MODEL', model[key], key)
                  return !_.isNil(model[key].importable) && model[key].importable ? (
                     <Form.Item
                        label={languageManager.getMessage(this.props.commonState, 'component.label.' + (!_.isNil(model[key].label) ? model[key].label : key))}
                        key={key}
                        name={key}
                        rules={[{ required: !_.isNil(model[key].required) ? model[key].required : false }]}
                     >
                        <Select
                           showSearch
                           allowClear={true}
                           style={{ width: 200 }}
                           placeholder="Seleziona la colonna"
                           optionFilterProp="children"
                           disabled={_.isEmpty(this.state.currentHeaders)}
                        >
                           {
                              this.state.currentHeaders.map((header, index) => {
                                 if (!_.isNil(header)) {
                                    return <Option key={index} value={header}>{header}</Option>
                                 }
                              })
                           }
                        </Select>
                     </Form.Item>
                  ) : null
               })
            }
            <Form.Item label="language" name="language" noStyle><Input type="hidden" /></Form.Item>
         </Form>
      )

      return (
         <Drawer
            title={languageManager.getMessage(this.props.commonState, 'component.stock_suppliers.import')}
            width={700}
            onClose={this.props.onClose}
            visible={this.props.visible}
            drawerStyle={{ paddingTop: 70 }}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
               <div className='float-right'>
                  <Space>
                     <Button onClick={this.props.onClose} disabled={this.state.formLoader}>Chiudi</Button>
                     <Button form="FormImportSupplierStocks" type="primary" htmlType="submit" loading={this.state.formLoader}>Importa</Button>
                  </Space>
               </div>
            }
         >
            {form}
         </Drawer>
      )
   }
}

function mapStateToProps(state) {
   return {
      authState: state.authenticationState,
      commonState: state.commonState
   };
}

export default connect(mapStateToProps)(DrawerImportStocks)